import axios from 'axios';
import { net_api_url } from 'components/Store';
import ChangeSearchQuery from './changeSearchQuery';
import getSearchWithinHash from './getSearchWithinHash';
import replaceInvertedQuotes from 'components/Dashboard/utilities/replaceInvertedQuotes';
const callHightlightContentAPI = async (props) => {
  const [objectId, objectType, query, andQueries, source] = props;
  try {
    let requestHeaders;
    if (source) {
      requestHeaders = {
        signal: source?.signal,
      };
    }
    let contentHightlighted = await axios.post(
      `${net_api_url}/api/search/highlight-content`,
      {
        objectId: objectId,
        objectType: objectType,
        query: replaceInvertedQuotes(query),
        andQueries: andQueries,
        searchWithinQuery: getSearchWithinHash() ? ChangeSearchQuery(getSearchWithinHash()) : '',
      },
      requestHeaders
    );
    return contentHightlighted.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

export default callHightlightContentAPI;
